export class FatalError extends Error {
  isFatal: boolean;

  constructor(message: string) {
    super(message);
    this.isFatal = true;
  }
}
